import React from 'react';
import { Card, Row, Col, Statistic, Space, Button, Select } from 'antd';
import {
  ReloadOutlined,
  FullscreenOutlined,
  SettingOutlined
} from '@ant-design/icons';
import { GenericCardsStatistic } from '@ms/shared-components';
import { createStatisticData } from '../configs/statisticConfig';
import {
  getFloorStatistics,
  getSpaceTypeDistribution
} from '../utils/spaceUtils';
import { mockVisualData } from '../configs/mockData';

const { Option } = Select;

interface OverviewTabProps {
  selectedFloor: string;
  onFloorChange: (floorId: string) => void;
  onRefresh: () => void;
  onFullscreen: () => void;
  onSettings: () => void;
}

const OverviewTab: React.FC<OverviewTabProps> = ({
  selectedFloor,
  onFloorChange,
  onRefresh,
  onFullscreen,
  onSettings
}) => {
  const statisticData = createStatisticData();
  const floorStats = getFloorStatistics(selectedFloor);
  const spaceTypes = getSpaceTypeDistribution();

  return (
    <div>
      {/* 统计卡片 */}
      <GenericCardsStatistic
        data={statisticData}
        columns={4}
        style={{ marginBottom: 16 }}
      />

      {/* 楼层选择器 */}
      <Card title="楼层选择" style={{ marginBottom: 16 }}>
        <Space>
          <Select
            value={selectedFloor}
            onChange={onFloorChange}
            style={{ width: 200 }}
            placeholder="选择楼层"
          >
            {mockVisualData.floors.map((floor) => (
              <Option key={floor.id} value={floor.id}>
                {floor.name} ({floor.spaces}个空间)
              </Option>
            ))}
          </Select>
          <Button icon={<ReloadOutlined />} onClick={onRefresh}>
            刷新
          </Button>
          <Button icon={<FullscreenOutlined />} onClick={onFullscreen}>
            全屏
          </Button>
          <Button icon={<SettingOutlined />} onClick={onSettings}>
            设置
          </Button>
        </Space>
      </Card>

      {/* 楼层详情 */}
      {selectedFloor && (
        <Row gutter={16}>
          <Col span={8}>
            <Card title="楼层统计">
              <Statistic title="总空间数" value={floorStats.spaces} />
              <Statistic
                title="已占用"
                value={floorStats.occupied}
                valueStyle={{ color: '#52c41a' }}
              />
              <Statistic
                title="可用空间"
                value={floorStats.available}
                valueStyle={{ color: '#faad14' }}
              />
            </Card>
          </Col>
          <Col span={8}>
            <Card title="空间类型分布">
              {spaceTypes.map((type) => (
                <div key={type.type} style={{ marginBottom: 8 }}>
                  <span style={{ color: type.color, marginRight: 8 }}>●</span>
                  {type.type}: {type.count}个
                </div>
              ))}
            </Card>
          </Col>
          <Col span={8}>
            <Card title="操作面板">
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button type="primary" block>
                  查看平面图
                </Button>
                <Button block>空间详情</Button>
                <Button block>导出报告</Button>
              </Space>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default OverviewTab;
